export class KinolaRepeater {
    static repeaterRowSelector: string = '.js-kinola-repeater-row';
    public addButtonSelector: string = '.js-kinola-repeater-add';
    public removeButtonSelector: string = '.js-kinola-repeater-remove';

    public init(): void {
        $(document).on('click', this.addButtonSelector, (e) => {
            e.preventDefault();
            const $template = $($(e.target).data('template'));
            const $target = $($(e.target).data('target'));
            const $row = $template.children().clone();
            $row.find('select, input').each((index, element) => {
                $(element).attr('name', $(element).data('name'));
                if ($(element).data('required')) {
                    $(element).attr('required', $(element).data('required'));
                }
            });
            const $result = $row.appendTo($target);
            $result.trigger('repeaterElementAdd');
        });

        $(document).on('click', this.removeButtonSelector, (e) => {
            e.preventDefault();
            const $target = $(e.target).closest(KinolaRepeater.repeaterRowSelector);
            $target.trigger('repeaterElementRemove');
            $target.remove();
        });
    }
}

const kinolaRepeater: KinolaRepeater = new KinolaRepeater();
kinolaRepeater.init();
